import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // 钱包页
  {
    path: '/habiWallet/index',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletPage" */ '~/pages/Wallet/pages/WalletPage'
        )
    ),
  },
  // 金币
  {
    path: '/habiWalletTab',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Wallet" */ '~/pages/Wallet')
    ),
  },
  // 钻石
  {
    path: '/habiWalletTab/:type',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Wallet" */ '~/pages/Wallet')
    ),
  },
  // 官方奖励
  {
    path: '/officialReward',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-OfficialReward" */ '~/pages/Wallet/pages/OfficialReward')
    ),
  },
  // 官方奖励详情页
  {
    path: '/officialReward/detail',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-OfficialRewardDetail" */ '~/pages/Wallet/pages/RewardDetail')
    ),
  },
  // 金币/钻石详情页
  {
    path: '/habiWallet/diamonds/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-DiamondsDetail" */ '~/pages/Wallet/pages/DiamondsDetail'
        )
    ),
  },
  // 币商列表
  {
    path: '/habiWallet/Coinagency/list',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-Coinagency" */ '~/pages/Wallet/pages/Coinagency'
        )
    ),
  },
  // 充值回调
  {
    path: '/habiWallet/CallBack/:orderId',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-LoadingCallback" */ '~/pages/Wallet/pages/LoadingCallback'
        )
    ),
  },
] as RouteConfig[]
